/** @type {Record<string, boolean>} */
let features = {};

export function setFeatureFlags(nextFeatures) {
  features = { ...nextFeatures };
}

export function isFeatureEnabled(key) {
  return Boolean(features[key]);
}

export function getFeatureFlags() {
  return { ...features };
}
